import React, { useState } from 'react';
import PolicyUpdates from './PolicyUpdates';
import CountriesDropdown from 'components/Common/countries-dropdown';

export default function HomePolicyUpdates() {

    const [countryID, setCountryID] = useState(null);

    return (
        <>
            <div className="country-selection mb-3">
                <span className="mr-2 text-nowrap">Showing data for </span>
                <CountriesDropdown countryID={countryID} setCountryID={setCountryID} hasRAC={true} />
            </div>
            <PolicyUpdates externalCountryID={countryID} showAdd={false}/>
        </>
    )
}